import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";

interface ProductSkuProps {
  productSku: string;
}

const useStyles = makeStyles(
  () => ({
    contentWrapper: {
      backgroundColor: "#C6DDFF",
      borderRadius: "25px",
      display: "inline",
      fontSize: "9px",
      padding: "6px",
      paddingLeft: "9px",
      whiteSpace: "nowrap"
    },
    label: {
      fontWeight: 600,
      paddingRight: "11px"
    }
  }),
  { name: "ProductSku" }
);

const ProductSku: React.FC<ProductSkuProps> = props => {
  const { productSku } = props;
  const classes = useStyles(props);

  return (
    <div className={classes.contentWrapper}>
      <span className={classes.label}>{productSku}</span>
    </div>
  );
};

export default ProductSku;
